import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage, t } from '../utils/i18n';
import { useCart } from '../contexts/CartContext';
import StripeCheckout from './StripeCheckout';

const CheckoutForm = ({ onCancel, onCheckoutComplete }) => {
  const { language } = useLanguage();
  const { setAlertInfo } = useCart();

  const handlePaymentSuccess = (result) => {
    setAlertInfo({
      type: 'success',
      message: '¡Pago procesado exitosamente! Recibirás un email de confirmación.'
    });
    
    if (onCheckoutComplete) {
      onCheckoutComplete(result);
    }
  };

  const handlePaymentError = (error) => {
    setAlertInfo({
      type: 'error',
      message: error
    });
  };

  return (
    <div className="max-w-4xl mx-auto px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative"
      >
        <button 
          onClick={onCancel}
          className="absolute top-4 right-4 z-10 text-white/80 hover:text-white bg-black/20 rounded-full p-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="bg-white/10 backdrop-blur-md rounded-[2rem] p-8 border border-white/20">
          <h2 className="text-3xl font-bold text-white mb-8 text-center">
            Proceso de Compra
          </h2>

          <StripeCheckout 
            onSuccess={handlePaymentSuccess}
            onError={handlePaymentError}
            onCancel={onCancel}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default CheckoutForm;
